module.exports = __webpack_public_path__ + "static/ninja-get-good-225279327501192ce853428c1b146d8e.jpg";